import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import "./contact.scss";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { IoLogoWhatsapp } from "react-icons/io";
import { AiFillInstagram } from "react-icons/ai";
import { IoLocation } from "react-icons/io5";
import { IoIosSend } from "react-icons/io";
import { Helmet } from "react-helmet";

const Contact = ({ result, setResult }) => {
  const textRef = useRef(null);

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");

    const formData = new FormData(event.target);
    formData.append("access_key", "e60046c7-fc21-46af-bc14-714200ed940d");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      setResult("Error");
    }
  };

  useEffect(() => {
    const tl = gsap.timeline({ defaults: { ease: "power4.out" } });

    tl.fromTo(
      textRef.current,
      { y: 10, opacity: 0 }, // start position (100px down)
      { y: 0, opacity: 1, duration: 1, ease: "power2.inOut" } // end position
    );

    tl.fromTo(
      textRef.current,
      { clipPath: "inset(50% 0 50% 0)" }, // start: hidden from center
      {
        clipPath: "inset(0% 0 0% 0)", // end: fully visible
        duration: 1.5,
        ease: "power2.inOut",
      }
    );
  }, []);

  return (
    <>
      <div className="contact_main">
        <Helmet>
          <title>Contact RenderX Architects</title>
          <meta
            name="description"
            content="Contact RenderX Architects Chennai for planning, construction, interior design, and exterior elevation services. Call +91 80561 66287."
          />

          <script type="application/ld+json">
            {`
    {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "url": "https://renderxarchitects.com/contact",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91 80561 66287",
        "email": "renderx.ch@gmail.com",
        "contactType": "Customer Service",
        "areaServed": "IN",
        "availableLanguage": ["English", "Tamil"]
      }
    }
    `}
          </script>
        </Helmet>

        <div className="contact_heading">
          <h1 ref={textRef}>CONTACT US</h1>
        </div>
        <div className="contact_container">
          {window.innerWidth >= 768 && (
            <div className="container_heading">
              <h2>LET'S GET IN TOUCH</h2>
            </div>
          )}
          <div className="contact_sections">
            <div className="contact_section1">
              <div className="contact_details address_div">
                <h5>ADDRESS</h5>
                <div className="">
                  <IoLocation />
                  <a>
                    12/16, Zackriya Colony, 1st Street, Kodambakkam, Chennai-24,
                    Chennai, Tamil Nadu 600094
                  </a>
                </div>
              </div>
              <div className="contact_details call_div">
                <h5>CONTACT</h5>
                <div className="">
                  <FaPhoneAlt />
                  <a href="tel:+918056166287">+91 80561 66287</a>
                </div>
                <div className="">
                  <MdEmail />
                  <a href="mailto:irfan@renderx-architects.com">
                    renderx.ch@gmail.com
                  </a>
                </div>
                <div className="">
                  <IoLogoWhatsapp />
                  <a
                    href="https://wa.me/918056166287?text=Hello%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services."
                    target="_blank"
                    rel="noopener"
                  >
                    +91 80561 66287
                  </a>
                </div>
              </div>
              <div className="contact_details social_div">
                <h5>SOCIAL</h5>
                <div className="">
                  <a
                    href="https://wa.me/918056166287?text=Hello%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services."
                    target="_blank"
                    rel="noopener"
                  >
                    <IoLogoWhatsapp />
                  </a>
                  <a
                    href="https://www.instagram.com/renderxarchitects/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <AiFillInstagram />
                  </a>
                  <a href="mailto:renderx.ch@gmail.com">
                    <MdEmail />
                  </a>
                </div>
              </div>
            </div>
            {window.innerWidth < 768 && (
              <div className="container_heading_2">
                <h2>LET'S GET IN TOUCH</h2>
              </div>
            )}
            <div className="contact_section2">
              <form onSubmit={onSubmit}>
                <input
                  type="hidden"
                  name="subject"
                  value="Form Submitted in www.renderxarchitects.com"
                ></input>
                <input
                  type="hidden"
                  name="from_name"
                  value="RenderxArchitects.com"
                ></input>
                <div className="input_div">
                  <p>
                    NAME<sup>*</sup>
                  </p>
                  <input name="Name" type="text" required placeholder="Name" />
                </div>
                <div className="input_div">
                  <p>
                    Email<sup>*</sup>
                  </p>
                  <input
                    name="Email"
                    type="email"
                    required
                    placeholder="Email"
                  />
                </div>
                <div className="input_div">
                  <p>
                    Phone<sup>*</sup>
                  </p>
                  <input
                    name="Phone Number"
                    type="tel"
                    required
                    placeholder="Phone"
                  />
                </div>
                <div className="input_div">
                  <p>
                    Message<sup>*</sup>
                  </p>
                  <textarea
                    name="Message"
                    type="text"
                    required
                    placeholder="Message"
                  />
                </div>
                <div className="form_btn_div">
                  <button type="submit">
                    SEND <IoIosSend />
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="contact_map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.696954156828!2d80.2298735!3d13.054951599999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267c3286b2841%3A0x763f835bb8570e93!2sRenderX%20Architects!5e0!3m2!1sen!2sin!4v1763191816243!5m2!1sen!2sin"
              width="600"
              height="450"
              allowFullScreen={false}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
